export const stateCheckListKo = [
    { value: '강원', label: '강원도' },
    { value: '경기', label: '경기도' },
    { value: '경남', label: '경남' },
    { value: '경북', label: '경북' },
    { value: '광주', label: '광주시' },
    { value: '대구', label: '대구시' },
    { value: '대전', label: '대전시' },
    { value: '부산', label: '부산시' },
    { value: '서울', label: '서울시' },
    { value: '세종', label: '세종시' },
    { value: '울산', label: '울산시' },
    { value: '인천', label: '인천시' },
    { value: '전남', label: '전남' },
    { value: '전북', label: '전북' },
    { value: '제주', label: '제주시' },
    { value: '충남', label: '충남' },
    { value: '충북', label: '충북' }
];

export const stateCheckList = [
    { value: 'Seoul', label: 'Seoul' },
    { value: 'Busan', label: 'Busan' },
    { value: 'Daegu', label: 'Daegu' },
    { value: 'Incheon', label: 'Incheon' },
    { value: 'Gwangju', label: 'Gwangju' },
    { value: 'Daejeon', label: 'Daejeon' },
    { value: 'Ulsan', label: 'Ulsan' },
    { value: 'Gyeonggi', label: 'Gyeonggi' },
    { value: 'Gangwon', label: 'Gangwon' },
    { value: 'ChungBuk', label: 'North Chungcheong' },
    { value: 'ChungNam', label: 'South Chungcheong' },
    { value: 'JunBuk', label: 'North Jeolla' },
    { value: 'JunNam', label: 'South Jeolla' },
    { value: 'GyeongBuk', label: 'North Gyeongsang' },
    { value: 'GyeongNam', label: 'South Gyeongsang' },
    { value: 'Jeju', label: 'Jeju' },
    { value: 'Sejong', label: 'Sejong' }
];

export const cityCheck = [
    'CT',
    'DN',
    'HN',
    'HP',
    'SG',
    'HCM',
    'KR-11',
    'KR-26',
    'KR-27',
    'KR-28',
    'KR-29',
    'KR-30',
    'KR-31',
    'KR-41',
    'KR-42',
    'KR-43',
    'KR-49',
    '11',
    '26',
    '27',
    '28',
    '29',
    '30',
    '31',
    '41',
    '42',
    '43',
    '49',
    'Seoul',
    'Busan',
    'Daegu',
    'Incheon',
    'Gwangju',
    'Daejeon',
    'Ulsan',
    'Gyeonggi',
    'Gangwon',
    'North Chungcheong',
    'Sejong',
    'Jeju',
    '서울',
    '부산',
    '대구',
    '인천',
    '광주',
    '대전',
    '울산',
    '경기',
    '강원',
    '충정북도',
    '제주',
    '세종'
];

export const stateCheckListMixed = [
    { value: '강원', label: '강원도' },
    { value: '경기', label: '경기도' },
    { value: '경남', label: '경남' },
    { value: '경북', label: '경북' },
    { value: '광주', label: '광주시' },
    { value: '대구', label: '대구시' },
    { value: '대전', label: '대전시' },
    { value: '부산', label: '부산시' },
    { value: '서울', label: '서울시' },
    { value: '세종', label: '세종시' },
    { value: '울산', label: '울산시' },
    { value: '인천', label: '인천시' },
    { value: '전남', label: '전남' },
    { value: '전북', label: '전북' },
    { value: '제주', label: '제주시' },
    { value: '충남', label: '충남' },
    { value: '충북', label: '충북' },
    { value: 'Seoul', label: 'Seoul' },
    { value: 'Busan', label: 'Busan' },
    { value: 'Daegu', label: 'Daegu' },
    { value: 'Incheon', label: 'Incheon' },
    { value: 'Gwangju', label: 'Gwangju' },
    { value: 'Daejeon', label: 'Daejeon' },
    { value: 'Ulsan', label: 'Ulsan' },
    { value: 'Gyeonggi', label: 'Gyeonggi' },
    { value: 'Gangwon', label: 'Gangwon' },
    { value: 'ChungBuk', label: 'North Chungcheong' },
    { value: 'ChungNam', label: 'South Chungcheong' },
    { value: 'JunBuk', label: 'North Jeolla' },
    { value: 'JunNam', label: 'South Jeolla' },
    { value: 'GyeongBuk', label: 'North Gyeongsang' },
    { value: 'GyeongNam', label: 'South Gyeongsang' },
    { value: 'Jeju', label: 'Jeju' },
    { value: 'Sejong', label: 'Sejong' }
];

export const ArgState = [
    { key: 'CT', value: 'Catamarca' },
    { key: 'CC', value: 'Chaco' },
    { key: 'CH', value: 'Chubut' },
    { key: 'C', value: 'Ciudad Autónoma de Buenos Aires' },
    { key: 'CB', value: 'Córdoba' },
    { key: 'CN', value: 'Corrientes' },
    { key: 'ER', value: 'Entre Ríos' },
    { key: 'FM', value: 'Formosa' },
    { key: 'JY', value: 'Jujuy' },
    { key: 'LP', value: 'La Pampa' },
    { key: 'LR', value: 'La Rioja' },
    { key: 'MZ', value: 'Mendoza' },
    { key: 'MN', value: 'Misiones' },
    { key: 'NQ', value: 'Neuquén' },
    { key: 'BA', value: 'Provincia de Buenos Aires' },
    { key: 'RN', value: 'Río Negro' },
    { key: 'SA', value: 'Salta' },
    { key: 'SJ', value: 'San Juan' },
    { key: 'SL', value: 'San Luis' },
    { key: 'SC', value: 'Santa Cruz' },
    { key: 'SF', value: 'Santa Fe' },
    { key: 'SE', value: 'Santiago del Estero' },
    { key: 'TF', value: 'Tierra del Fuego' },
    { key: 'TM', value: 'Tucumán' }
];
